"use client";

import Image from "next/image";
import { BRAND_LOGO } from "../../navbar/Navbar2026";
import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import styles from "./hero-scroll.module.css";

export default function HeroSplash({ children }) {
  const splashRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: splashRef,
    offset: ["start start", "end start"],
  });
  const opacity = useTransform(scrollYProgress, [0, 0.65], [1, 0]);

  return (
    <div
      ref={splashRef}
      data-hero-splash
      className="relative flex min-h-[calc(100svh-40px)] w-full flex-col px-6 pb-12 pt-24 lg:min-h-svh lg:pb-8 lg:pt-24"
    >
      {/* The logo stays in document flow. Only opacity changes on scroll;
          nothing is measured against or moved into the navbar. */}
      <motion.div
        aria-hidden
        style={{ opacity }}
        className={`${styles.logoFade} relative z-10 flex flex-1 items-center justify-center py-8 lg:py-4`}
      >
        <Image
          src={BRAND_LOGO.src}
          alt=""
          width={BRAND_LOGO.width}
          height={BRAND_LOGO.height}
          sizes="(max-width: 767px) 80vw, (max-width: 1446px) 56vw, 810px"
          priority
          className="h-auto w-[min(80vw,810px)] max-w-full md:w-[clamp(260px,56vw,810px)]"
        />
      </motion.div>
      <div className="relative z-10">{children}</div>
    </div>
  );
}
